import ru from './ru/ru'
import en from './en/en'
import uk from './uk/uk'
import uz from './uz/uz'
import az from './az/az'
import kz from './kz/kz'
import kg from './kg/kg'

export default {
    ru,
    en,
    uk,
    uz,
    az,
    kz,
    kg
}
